import { Option, Record as EffectRecord } from 'effect'

// API が振る ID（セッション、ターン）が届くまで、表示と状態のキーに使う仮の ID。
// 指示を送った時点で、API の応答を待たずに指示と「考え中」を出すために使う（仕様の「指示の送信と応答」）

const PENDING_ID_PREFIX = 'pending-'

export const pendingIdOf = (uuid: string): string => `${PENDING_ID_PREFIX}${uuid}`

export const isPendingId = (id: string): boolean => id.startsWith(PENDING_ID_PREFIX)

/**
 * 仮の ID のキーを、API が振った ID に付け替える。仮の ID のキーがなければ何もしない。
 */
export const renamePendingKey = <V>(
  record: Readonly<Record<string, V>>,
  pendingId: string,
  id: string,
): Readonly<Record<string, V>> =>
  Option.match(EffectRecord.get(record, pendingId), {
    onNone: () => record,
    onSome: (value) => EffectRecord.set(EffectRecord.remove(record, pendingId), id, value),
  })
